var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.784 11.232l-5.92-8.384h3.2l4.416 6.464 4.384-6.464h3.168l-5.92 8.384L20.352 20h-3.2l-4.672-6.848L7.744 20H4.576l6.208-8.768z",
    fill: "#fff"
  })));
}
export default SvgCloseWhite;